import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { TAB_3B_RESET_HELP_BLOCK } from "actions";

const HelpBlockTab3B = props => {
  const { helpBlockTab3BIsOpen, domain } = props;
  return (
    <div className={classNames("right_slide_block invoice_slide_help", { opnd: helpBlockTab3BIsOpen })}>
      <div className="right_slide_block--inner">
        <div className="auto_fill_slide--content">
          <h2>{domain.Strings.helpBlock3BTitle}</h2>
          <p>{domain.Strings.helpBlock3BSubTitle}</p>
          <p>
            <strong>{domain.Strings.helpBlock3BSalesLabel}</strong>
            {domain.Strings.helpBlock3BSalesExtra}
          </p>
          <p>
            <strong>{domain.Strings.helpBlock3BCustomersLabel}</strong>
            {domain.Strings.helpBlock3BCustomersExtra}
          </p>
          <p>
            <strong>{domain.Strings.helpBlock3BCreditLabel}</strong>
            {domain.Strings.helpBlock3BCreditExtra}
          </p>
          <div>
            <a onClick={props.hide} className="back_btn">
              {domain.Strings.helpBlock3BBackBtn}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = dispatch => {
  return {
    hide: () => dispatch({ type: TAB_3B_RESET_HELP_BLOCK })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HelpBlockTab3B);
